<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-4 row">
      <div class="col-lg-6 col-sm-12">
        <div class="font20">
          <i class="fa fa-arrow-left click px-3" routerLink="../"></i>Create
          Learning Path
        </div>
      </div>
      <div class="col-lg-6 col-sm-12 text-right sm-mt sm-text-left">
        <div>
          <button
            class="btn btn-secondary btn-md"
            (click)="createLearningPath()"
          >
            Create
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-12">
        <div class="bg-white px-4 py-1 bg-box-shadow">
          <form action="" [formGroup]="learningPathForm">
            <div class="my-4 d-flex">
              <input
                type="text"
                class="common-input form-control"
                placeholder="Learning Path Name"
                formControlName="name"
                [ngClass]="{
                  'is-invalid':
                    learningPathForm.get('name').errors &&
                    learningPathForm.get('name').touched
                }"
              />
              <span class="text-red font18">*</span>
            </div>
            <div class="my-4">
              <textarea
                class="common-input"
                placeholder="Description"
                formControlName="description"
              ></textarea>
            </div>

            <div class="my-4 d-flex">
              <label class="check-container">
                <input type="checkbox" hidden formControlName="restricted" />
                <span class="checkmark"></span>
              </label>
              <span class="font14">Set restrictions</span>
            </div>
            <div *ngIf="this.learningPathForm.get('restricted').value == true">
              <div class="my-4 d-flex">
                <select
                  type="text"
                  class="common-input"
                  (change)="getRestriction($event.target.value)"
                >
                  <option value="">--Select restriction type--</option>
                  <option value="Department">Restrict by Department</option>
                  <option value="Division">Restrict by Division</option>
                  <option value="Unit">Restrict by Unit</option>
                </select>
                <span class="text-red font18">*</span>
              </div>
              <div class="my-4 d-flex" *ngIf="department">
                <select
                  type="text"
                  class="common-input"
                  (change)="setRestrictedId($event.target.value, 'DEPARTMENT')"
                >
                  <option value="">--Select department--</option>
                  <option
                    *ngFor="let department of departments"
                    value="{{ department?.id }}"
                  >
                    {{ department?.name }}
                  </option>
                </select>
                <span class="text-red font18">*</span>
              </div>
              <div class="my-4 d-flex" *ngIf="division">
                <select
                  type="text"
                  class="common-input"
                  (change)="setRestrictedId($event.target.value, 'DIVISION')"
                >
                  <option value="">--Select division--</option>
                  <option
                    *ngFor="let division of divisions"
                    value="{{ division?.id }}"
                  >
                    {{ division?.name }}
                  </option>
                </select>
                <span class="text-red font18">*</span>
              </div>

              <div class="my-4 d-flex" *ngIf="unit">
                <select
                  type="text"
                  class="common-input"
                  (change)="setRestrictedId($event.target.value, 'UNIT')"
                >
                  <option value="">--Select unit--</option>
                  <option *ngFor="let unit of units" value="{{ unit?.id }}">
                    {{ unit?.name }}
                  </option>
                </select>
                <span class="text-red font18">*</span>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12">
        <div class="bg-box-shadow">
          <div
            class="bg-white px-4 py-3 d-flex align-items-center justify-content-between"
          >
            <div class="font18 font-bold">
              Courses
              <span class="badge-count badge-green">{{
                selectedCourses.length
              }}</span>
            </div>
            <div>
              <button
                data-toggle="modal"
                data-target="#assignModal"
                class="btn btn-outline-secondary btn-sm"
              >
                Add Course
              </button>
            </div>
          </div>
          <hr class="my-0" />
          <div class="bg-white pb-5 pt-1 px-4 course-container">
            <p *ngIf="selectedCourses.length == 0">
              Add Courses you want to assign
            </p>
            <div
              class="row my-4"
              id="courses"
              *ngFor="let course of selectedCourses"
            >
              <div class="col-11">
                <div class="row">
                  <div class="col-lg-4 col-sm-12">
                    <div class="p-r">
                      <img
                        src="{{ course?.imageUrl }}"
                        alt=""
                        class="border-radius w-100 courseImg"
                      />
                      <!-- <span class="badge {{ course }}">{{ course }}</span> -->
                    </div>
                  </div>
                  <div class="col-lg-8 col-sm-12 my-auto">
                    <p class="font-bold">
                      {{ course?.title }}
                    </p>
                    <p class="text-grey font12">
                      {{ course?.category?.name }} |
                      {{ course?.subCategory?.name }}
                    </p>
                    <div
                      class="mt-4 d-flex justify-content-between record py-2 px-3"
                    >
                      <div class="rating {{ rating(course) }}">
                        <span>☆</span><span>☆</span><span>☆</span><span>☆</span
                        ><span>☆</span>
                      </div>
                      <div class="font12">Level: {{ course?.level }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1 click" (click)="removeCourse(course)">
                <img src="assets/images/close.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-wrapper mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>

<div
  class="modal fade"
  id="assignModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="assignModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="assignModalLabel">Assign Courses</h2>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="nav-card bg-white px-3 py-2">
          <div
            class="bg-white pb-2 d-flex align-items-center justify-content-between"
          >
            <div class="font18 font-bold">All Courses</div>
            <div>
              <input
                class="search px-3"
                type="search"
                placeholder="search"
                #query
                (keyup)="filter(query.value)"
              />
            </div>
          </div>
        </div>
        <div class="coursesToAssign">
          <div class="fixedHeight">
            <label
              class="check-container mb-4"
              for="checkbox{{ i }}"
              *ngFor="let course of courses; index as i"
            >
              <input
                type="checkbox"
                id="checkbox{{ i }}"
                (click)="selectDeselectCourse(course)"
              />
              <span class="checkmark"></span>
              <p class="font16 ml-2">{{ course?.title }}</p>
            </label>
          </div>
        </div>
        <div
          class="selected d-flex align-items-center justify-content-center mb-5"
        >
          <p class="font18 m-0">{{ selectCourses.length }} Selected</p>
        </div>
        <div class="d-flex justify-content-center my-3">
          <button
            (click)="addCourse()"
            type="button"
            class="btn btn-secondary btn-md"
            data-dismiss="modal"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
